import * as Types from '@/constants/Types';

export const timeZones = [
  {
    id: 1,
    name: 'Eastern',
    abbreviation: 'EST',
    area: 'America',
    location: 'New York',
    utcOffset: '-05:00',
  },
  {
    id: 2,
    name: 'Central',
    abbreviation: 'CST',
    area: 'America',
    location: 'Chicago',
    utcOffset: '-06:00',
  },
  {
    id: 3,
    name: 'Mountain',
    abbreviation: 'MST',
    area: 'America',
    location: 'Denver',
    utcOffset: '-07:00',
  },
  {
    id: 4,
    name: 'Pacific',
    abbreviation: 'PST',
    area: 'America',
    location: 'Los Angeles',
    utcOffset: '-08:00',
  },
  {
    id: 5,
    name: 'Alaska',
    abbreviation: 'AKST',
    area: 'America',
    location: 'Anchorage',
    utcOffset: '-09:00',
  },
  {
    id: 6,
    name: 'Hawaii',
    abbreviation: 'HST',
    area: 'Pacific',
    location: 'Honolulu',
    utcOffset: '-10:00',
  },
];

export const businessHours = [
  { id: 1, label: '12:00am', value: '00:00:00' },
  { id: 2, label: '12:15am', value: '00:15:00' },
  { id: 3, label: '12:30am', value: '00:30:00' },
  { id: 4, label: '12:45am', value: '00:45:00' },
  { id: 5, label: '1:00am', value: '01:00:00' },
  { id: 6, label: '1:15am', value: '01:15:00' },
  { id: 7, label: '1:30am', value: '01:30:00' },
  { id: 8, label: '1:45am', value: '01:45:00' },
  { id: 9, label: '2:00am', value: '02:00:00' },
  { id: 10, label: '2:15am', value: '02:15:00' },
  { id: 11, label: '2:30am', value: '02:30:00' },
  { id: 12, label: '2:45am', value: '02:45:00' },
  { id: 13, label: '3:00am', value: '03:00:00' },
  { id: 14, label: '3:15am', value: '03:15:00' },
  { id: 15, label: '3:30am', value: '03:30:00' },
  { id: 16, label: '3:45am', value: '03:45:00' },
  { id: 17, label: '4:00am', value: '04:00:00' },
  { id: 18, label: '4:15am', value: '04:15:00' },
  { id: 19, label: '4:30am', value: '04:30:00' },
  { id: 20, label: '4:45am', value: '04:45:00' },
  { id: 21, label: '5:00am', value: '05:00:00' },
  { id: 22, label: '5:15am', value: '05:15:00' },
  { id: 23, label: '5:30am', value: '05:30:00' },
  { id: 24, label: '5:45am', value: '05:45:00' },
  { id: 25, label: '6:00am', value: '06:00:00' },
  { id: 26, label: '6:15am', value: '06:15:00' },
  { id: 27, label: '6:30am', value: '06:30:00' },
  { id: 28, label: '6:45am', value: '06:45:00' },
  { id: 29, label: '7:00am', value: '07:00:00' },
  { id: 30, label: '7:15am', value: '07:15:00' },
  { id: 31, label: '7:30am', value: '07:30:00' },
  { id: 32, label: '7:45am', value: '07:45:00' },
  { id: 33, label: '8:00am', value: '08:00:00' },
  { id: 34, label: '8:15am', value: '08:15:00' },
  { id: 35, label: '8:30am', value: '08:30:00' },
  { id: 36, label: '8:45am', value: '08:45:00' },
  { id: 37, label: '9:00am', value: '09:00:00' },
  { id: 38, label: '9:15am', value: '09:15:00' },
  { id: 39, label: '9:30am', value: '09:30:00' },
  { id: 40, label: '9:45am', value: '09:45:00' },
  { id: 41, label: '10:00am', value: '10:00:00' },
  { id: 42, label: '10:15am', value: '10:15:00' },
  { id: 43, label: '10:30am', value: '10:30:00' },
  { id: 44, label: '10:45am', value: '10:45:00' },
  { id: 45, label: '11:00am', value: '11:00:00' },
  { id: 46, label: '11:15am', value: '11:15:00' },
  { id: 47, label: '11:30am', value: '11:30:00' },
  { id: 48, label: '11:45am', value: '11:45:00' },
  { id: 49, label: '12:00pm', value: '12:00:00' },
  { id: 50, label: '12:15pm', value: '12:15:00' },
  { id: 51, label: '12:30pm', value: '12:30:00' },
  { id: 52, label: '12:45pm', value: '12:45:00' },
  { id: 53, label: '1:00pm', value: '13:00:00' },
  { id: 54, label: '1:15pm', value: '13:15:00' },
  { id: 55, label: '1:30pm', value: '13:30:00' },
  { id: 56, label: '1:45pm', value: '13:45:00' },
  { id: 57, label: '2:00pm', value: '14:00:00' },
  { id: 58, label: '2:15pm', value: '14:15:00' },
  { id: 59, label: '2:30pm', value: '14:30:00' },
  { id: 60, label: '2:45pm', value: '14:45:00' },
  { id: 61, label: '3:00pm', value: '15:00:00' },
  { id: 62, label: '3:15pm', value: '15:15:00' },
  { id: 63, label: '3:30pm', value: '15:30:00' },
  { id: 64, label: '3:45pm', value: '15:45:00' },
  { id: 65, label: '4:00pm', value: '16:00:00' },
  { id: 66, label: '4:15pm', value: '16:15:00' },
  { id: 67, label: '4:30pm', value: '16:30:00' },
  { id: 68, label: '4:45pm', value: '16:45:00' },
  { id: 69, label: '5:00pm', value: '17:00:00' },
  { id: 70, label: '5:15pm', value: '17:15:00' },
  { id: 71, label: '5:30pm', value: '17:30:00' },
  { id: 72, label: '5:45pm', value: '17:45:00' },
  { id: 73, label: '6:00pm', value: '18:00:00' },
  { id: 74, label: '6:15pm', value: '18:15:00' },
  { id: 75, label: '6:30pm', value: '18:30:00' },
  { id: 76, label: '6:45pm', value: '18:45:00' },
  { id: 77, label: '7:00pm', value: '19:00:00' },
  { id: 78, label: '7:15pm', value: '19:15:00' },
  { id: 79, label: '7:30pm', value: '19:30:00' },
  { id: 80, label: '7:45pm', value: '19:45:00' },
  { id: 81, label: '8:00pm', value: '20:00:00' },
  { id: 82, label: '8:15pm', value: '20:15:00' },
  { id: 83, label: '8:30pm', value: '20:30:00' },
  { id: 84, label: '8:45pm', value: '20:45:00' },
  { id: 85, label: '9:00pm', value: '21:00:00' },
  { id: 86, label: '9:15pm', value: '21:15:00' },
  { id: 87, label: '9:30pm', value: '21:30:00' },
  { id: 88, label: '9:45pm', value: '21:45:00' },
  { id: 89, label: '10:00pm', value: '22:00:00' },
  { id: 90, label: '10:15pm', value: '22:15:00' },
  { id: 91, label: '10:30pm', value: '22:30:00' },
  { id: 92, label: '10:45pm', value: '22:45:00' },
  { id: 93, label: '11:00pm', value: '23:00:00' },
  { id: 94, label: '11:15pm', value: '23:15:00' },
  { id: 95, label: '11:30pm', value: '23:30:00' },
  { id: 96, label: '11:45pm', value: '23:45:00' },
];

export const daysOfTheWeek = [
  {
    id: 1,
    name: 'Sunday',
    abbreviation: 'S',
    weekDayIndex: 0,
  },
  {
    id: 2,
    name: 'Monday',
    abbreviation: 'M',
    weekDayIndex: 1,
  },
  {
    id: 3,
    name: 'Tuesday',
    abbreviation: 'T',
    weekDayIndex: 2,
  },
  {
    id: 4,
    name: 'Wednesday',
    abbreviation: 'W',
    weekDayIndex: 3,
  },
  {
    id: 5,
    name: 'Thursday',
    abbreviation: 'T',
    weekDayIndex: 4,
  },
  {
    id: 6,
    name: 'Friday',
    abbreviation: 'F',
    weekDayIndex: 5,
  },
  {
    id: 7,
    name: 'Saturday',
    abbreviation: 'S',
    weekDayIndex: 6,
  },
];

export const standupReportingDays = [
  { id: Types.TYPE_REPORTING_DAY_YESTERDAY, label: 'yesterday', isRecommended: true },
  { id: Types.TYPE_REPORTING_DAY_TODAY, label: 'today', isRecommended: true },
  // { id: 3, label: 'tomorrow', isRecommended: false },
];
